import { CSSProperties } from 'react';
import './CarouselCard.scss';

export interface CarouselCardProps {
	imageUrl: string;
	style?: CSSProperties;
}

const CarouselCard: React.FC<CarouselCardProps> = props => {
	return (
		<div className='carousel-card' style={props.style}>
			<img src={props.imageUrl} alt='feature'></img>
		</div>
	);
};

export default CarouselCard;
